import { styled } from "goober";
import { Icon } from "./Icon";
import { PressButton } from "./PressButton";
import { Tooltip } from "./Tooltip";

const StyledPressButton = styled(PressButton)`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-secondary);

  &:hover {
    color: var(--red-600);
    background: var(--alpha4);
  }
`;

type Props = {
  name: string;
  onPress: () => void;
};

export function StepTestUnpinButton({ name, onPress }: Props) {
  return (
    <Tooltip content="Unpin step test">
      <StyledPressButton
        aria-label={`Unpin step test ${name}`}
        onPress={onPress}
      >
        <Icon name="x" size={12} />
      </StyledPressButton>
    </Tooltip>
  );
}
